import request from "@/utils/request";

// 获取璇玑连接
export const  gainXjUrl =(query) =>{
    return request({
        url: "/businessservice/eduai/gainXjUrl",
        method:"get",
        params: query
    })
}

// 获取是否有AI教研助手权限
export const  gainIsAiAide =(query) =>{
    return request({
        url: "/businessservice/eduai/gainIsAiAide",
        method:"get",
        params: query
    })
}